import Header from "@/types/app/header";

export default class CommunicationEmailNotificationUser {
  public static header: Header[] = [
    {
      text: "Customer",
      align: "start",
      sortable: true,
      value: "fullName",
      class: "item-table-header item-table-header-date",
      width: ""
    },    
    {
      text: "Email",
      align: "start",
      sortable: true,
      value: "email",
      class: "item-table-header item-table-header-amount",
      width: ""
    },    
    {
      text: "Link",
      align: "start",
      sortable: true,
      value: "link",
      class: "item-table-header item-table-header-url",
      width: ""
    },    
    {
      text: "Send Date",
      align: "start",      
      sortable: true,
      value: "dtSendEmail",
      class: "item-table-header item-table-header-authorName",
      width: ""
    },
  
    {
      text: "Status",
      align: "start",
      sortable: true,
      value: "status",
      class: "item-table-header item-table-header-subject",
      width: ""

    },
    {
      text: "Opens Count",
      align: "start",
      sortable: true,
      value: "opensCount",
      class: "item-table-header item-table-header-subject",
      width: ""

    }, 
    {
      text: "Clicks Count",
      align: "start",
      sortable: true,
      value: "clicksCount",
      class: "item-table-header item-table-header-subject",
      width: ""

    }, 
    {
      text: "Copy Email",
      align: "start",
      sortable: true,
      value: "copyEmail",
      class: "item-table-header item-table-header-authorName",
      width: ""
    },
    {
      text: "",
      align: "right",
      value: "actions",
      sortable: false,
      class: null,
      width: ""
    }
  ];
}
